/**
 * Shared anon_key helper — the same UUID-like key used by ChatLanding,
 * PersonalizedAnswerFlow, and ReadingFeedback to correlate a caller's
 * free-tier usage across page reloads.
 *
 * Kept in one place so the header AnswersLeftChip and the chat flow read
 * the exact same value. If we ever rotate the storage key or the
 * generation scheme, both surfaces update at once.
 */
const ANON_KEY_STORAGE = "lodestar.anon_key";

export function getAnonKey() {
    try {
        let key = localStorage.getItem(ANON_KEY_STORAGE);
        if (!key) {
            key = `anon_${crypto.randomUUID().replace(/-/g, "").slice(0, 20)}`;
            localStorage.setItem(ANON_KEY_STORAGE, key);
        }
        return key;
    } catch (e) {
        // Private-mode browsers throw on localStorage access. Return
        // null so callers can either omit the field or degrade gracefully.
        console.warn("[lodestar] getAnonKey storage failed:", e?.message || e);
        return null;
    }
}

/** Fire this after any action that consumes or restores a free answer
 *  so the header chip refreshes immediately (no polling required). */
export const CHAT_USAGE_EVENT = "lodestar:chat_usage_changed";

export function emitChatUsageChanged() {
    try { window.dispatchEvent(new Event(CHAT_USAGE_EVENT)); } catch { /* SSR */ }
}
